import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { JornadaSchema } from "../data/JornadaSchema";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import SelectField from "./controls/SelectField";
import TimeField from "./controls/TimeField";
import NumberField from "./controls/NumberField";
import Pagination from "./controls/Pagination";
import { isInvalid } from "../utils/forms";
import Button from "./controls/Button";

export function JornadaLaboralForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  diasSemana,
  disabled,
}) {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validationSchema={JornadaSchema}
      validateOnChange={true}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(jornadaLaboralForm) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Row>
            <Col>
              <Label>{t("jornadaLaboralForm.titulo")}</Label>
            </Col>
          </Row>
          <Row>
            <Col lg={3}>
              <SelectField
                id="jornadaLaboral_diaSemana"
                name="diaSemana"
                label={t("jornadaLaboral.diaSemana")}
                labelStyle={{ whiteSpace: "nowrap" }}
                value={jornadaLaboralForm.values?.diaSemana}
                onChange={(event) => jornadaLaboralForm.handleChange(event)}
                options={[
                  ...diasSemana,
                  ...(page >= 0 ? [jornadaLaboralForm.values?.diaSemana] : []),
                ]}
                emptyLabel="..."
                isInvalid={isInvalid("diaSemana", jornadaLaboralForm)}
                error={t(jornadaLaboralForm.errors.diaSemana)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <TimeField
                id="jornadaLaboral_inicio"
                name="inicio"
                label={t("jornadaLaboral.inicio")}
                value={jornadaLaboralForm.values?.inicio}
                onChange={(event) => jornadaLaboralForm.handleChange(event)}
                isInvalid={isInvalid("inicio", jornadaLaboralForm)}
                error={t(jornadaLaboralForm.errors.inicio)}
                disabled={disabled}
              />
            </Col>
            <Col lg={4}>
              <TimeField
                id="jornadaLaboral_termino"
                name="termino"
                label={t("jornadaLaboral.termino")}
                value={jornadaLaboralForm.values?.termino}
                onChange={(event) => jornadaLaboralForm.handleChange(event)}
                isInvalid={isInvalid("termino", jornadaLaboralForm)}
                error={t(jornadaLaboralForm.errors.termino)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={2}>
              <NumberField
                id="jornadaLaboral_turnos"
                name="turnos"
                label={t("jornadaLaboral.turnos")}
                labelStyle={{ whiteSpace: "nowrap" }}
                value={jornadaLaboralForm.values?.turnos}
                onChange={(event) => jornadaLaboralForm.handleChange(event)}
                isInvalid={isInvalid("turnos", jornadaLaboralForm)}
                error={t(jornadaLaboralForm.errors.turnos)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={6}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={6}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && pages < 7 && (
                  <Button
                    sm
                    variant="success"
                    value={t("jornadaLaboralForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("jornadaLaboralForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("jornadaLaboralForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    jornadaLaboralForm.submitForm();
                  }}
                  disabled={disabled}
                />
                {page === -1 && pages > 0 && (
                  <Button
                    sm
                    variant="default"
                    value={t("jornadaLaboralForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(0);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
